"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.GRID_PLACEHOLDER = exports.LIST_PLACEHOLDER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    LIST_PLACEHOLDER = (0, _cxs["default"])({
  width: "100%",
  height: "130px",
  overflow: "hidden"
});

exports.LIST_PLACEHOLDER = LIST_PLACEHOLDER;
var GRID_PLACEHOLDER = (0, _cxs["default"])({
  backgroundColor: "#fff",
  width: "auto",
  overflow: "hidden"
});
exports.GRID_PLACEHOLDER = GRID_PLACEHOLDER;